import { Page, PageTitle } from "@/components/page"
import { CRUDLoader } from "@/components/page/crudloader"
import { CRUDToolbar } from "@/components/page/crudtoolbar"
import { useDatabaseItem, usePage } from "@/components/page/hooks"
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { ulid } from "ulid"
import { z } from "zod"
import { reset as resetContact } from "@/lib/agents/integrations/channels/commands"


const FormSchema = z.object({
  name: z.string(),
  avatar: z.string().optional(),
  type: z.enum(["operator", "synthetic"]).optional(),
})

type FormData = z.infer<typeof FormSchema>

export function ContactCRUD() {

  const {
    data,
    loading,
    submit,
    toastSuccess,
    navigate,
    id,
  } = useDatabaseItem("contacts")

  const { team, } = usePage()


  const form = useForm<FormData>({
    resolver: zodResolver(FormSchema),
    defaultValues: data as FormData,
    values: data as FormData,
  })

  async function onSubmit(data: Contact) {
    data.id = ulid()
    data.team = team?.id
    await submit(data as any)
    toastSuccess()
    // navigate("/contacts")
    navigate(-1)

  }

  if (loading) return <CRUDLoader />

  return <Page>
    <div className="pb-8">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <PageTitle>
            <CRUDToolbar table="contacts" onSuccess={"/contacts"} onDelete={async () => { if (id) await resetContact(id) }} />
          </PageTitle>

          <div className="rgrid">
            <div className="row">
              <div className="rc-4">
                <FormField control={form.control} name="name" render={({ field }) => (
                  <FormItem>
                    <FormLabel>Name</FormLabel>
                    <FormControl><Input {...field} /></FormControl>
                    <FormMessage />
                  </FormItem>
                )} />
              </div>
              <div className="rc-4">
                <FormField control={form.control} name="type" render={({ field }) => (
                  <FormItem>
                    <FormLabel>Type</FormLabel>
                    <Select value={field.value} onValueChange={field.onChange} defaultValue={field.value}>
                      <FormControl>
                        <SelectTrigger>
                          <SelectValue placeholder="Select a type" />
                        </SelectTrigger>
                      </FormControl>
                      <SelectContent>
                        <SelectItem value="operator">Operator</SelectItem>
                        <SelectItem value="synthetic">Synthetic</SelectItem>
                      </SelectContent>
                    </Select>
                    <FormMessage />
                  </FormItem>
                )} />
              </div>
              <div className="rc-4">
                <FormField control={form.control} name="avatar" render={({ field }) => (
                  <FormItem>
                    <FormLabel>Avatar</FormLabel>
                    <FormControl><Input {...field} /></FormControl>
                    <FormMessage />
                  </FormItem>
                )} />
              </div>
            </div>
          </div>
        </form>
      </Form>
    </div>
  </Page>
}
